import SavingsProfilesTable from "./SavingsProfilesTable";
import { PensionProductType } from "../../../data/PensionProductType";
import TablePageWrapper from "../TablePageWrapper";
import { TableType } from "../../../data/TableType";

type SavingsProfilesPageProps = {
  pensionProductType: PensionProductType;
};
export default function SavingsProfilesPage({
  pensionProductType,
}: SavingsProfilesPageProps) {
  return (
    <TablePageWrapper
      pensionProductType={pensionProductType}
      tableType={TableType.SAVINGSPROFILES}
      tableTypeKey="savingsprofiles"
    >
      <SavingsProfilesTable pensionProductType={pensionProductType} />
    </TablePageWrapper>
  );
}
